import { useAppSound } from 'hooks';
import React from 'react';
import * as S from './Input.style';

export const Input = React.forwardRef((props, ref) => {
    const [playSound] = useAppSound('key');

    return <S.Input ref={ref} {...props} onKeyPress={playSound} />;
});
